import React, { useState, useCallback, useRef, useMemo } from 'react';
import Preview from '../components/builder/Preview/WidgetPreview';

export default function useWidgetPreview(widget) {
  const [isPreviewLoading, setIsPreviewLoading] = useState(true);
  const [widgetParameters, setWidgetParameters] = useState([]);
  const [widgetMeta, setWidgetMeta] = useState({});
  const remoteWidgetRef = useRef();
  const onChangeState = useCallback((state, widget = {}) => {
    setIsPreviewLoading(state === Preview.State.LOADING);
    setWidgetParameters(widget.parameters?.params || []);
    setWidgetMeta(widget.parameters || {});
  }, []);

  const WidgetPreview = useCallback((props = {}) => {
    return (
      <Preview
        ref={remoteWidgetRef}
        widget={widget}
        onChangeState={onChangeState}
        {...props}
      />
    );
  }, [widget.id, onChangeState]);
  const remoteWidget = useMemo(() => {
    return new Proxy({}, {
      get(_, action) {
        return (payload) => {
          remoteWidgetRef.current && (
            action === 'set'
              ? remoteWidgetRef.current.set(payload)
              : remoteWidgetRef.current.call(action, payload)
          );
        }
      }
    });
  }, []);
  return { WidgetPreview, remoteWidget, isPreviewLoading, widgetMeta, widgetParameters };
}